import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SecurityContext,
  ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { of, tap } from 'rxjs';
import { SvgIconService } from './svg-icon.service';

@Component({
  selector: 'app-svg-icon',
  template: `<span #icon [innerHTML]="svgIcon"></span>`,
  styles: `span {
    display: flex;
    svg {
      height: 100%;
    } 
  }`,
})
export class SvgIconComponent implements OnChanges {
  @Input() public name?: string;
  @Input() color?: string;
  @ViewChild('icon') icon?: ElementRef<HTMLSpanElement>;

  public svgIcon?: SafeHtml;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly svgService: SvgIconService
  ) {}

  ngOnChanges(): void {
    if (!this.name) {
      this.svgIcon = '';
      return;
    }
    this.svgService.getIcon(this.name).subscribe((rawValue) => {
      this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(rawValue);
      if (!this.color) {
        return;
      }
      return setTimeout(() => {
        const paths = this.icon?.nativeElement.getElementsByTagName(
          'path'
        ) as HTMLCollection;
        for (let i = 0; i < paths.length; i++) {
          const e = paths[i];
          e.setAttribute('fill', `var(--${this.color})`);
          if (e.getAttribute('stroke')) {
            e.setAttribute('stroke', `var(--${this.color})`);
          }
        }
      });
    });
  }
}
